import { render, staticRenderFns } from "./LayoutFooterless.vue?vue&type=template&id=8b5913f2"
import script from "./LayoutFooterless.vue?vue&type=script&lang=js"
export * from "./LayoutFooterless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b5913f2')) {
      api.createRecord('8b5913f2', component.options)
    } else {
      api.reload('8b5913f2', component.options)
    }
    module.hot.accept("./LayoutFooterless.vue?vue&type=template&id=8b5913f2", function () {
      api.rerender('8b5913f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/_layouts/layout-footerless/LayoutFooterless.vue"
export default component.exports